module.exports = __webpack_public_path__ + "img/dummy_post_image.d7572733.png";